import { create } from 'zustand'
import api from '../services/api'

export type MenuLayout = 'sidebar' | 'radial' | 'command' | 'dock'

const VALID_LAYOUTS: MenuLayout[] = ['sidebar', 'radial', 'command', 'dock']
const STORAGE_KEY = 'erp_menu_layout'

function applyLayoutToDOM(layout: MenuLayout) {
  document.documentElement.setAttribute('data-menu-layout', layout)
}

function getInitialLayout(): MenuLayout {
  const saved = localStorage.getItem(STORAGE_KEY) as MenuLayout | null
  if (saved && VALID_LAYOUTS.includes(saved)) return saved
  return 'sidebar'
}

const initialLayout = getInitialLayout()
applyLayoutToDOM(initialLayout)

interface MenuLayoutState {
  layout: MenuLayout
  setLayout: (layout: MenuLayout) => void
  loadLayoutFromServer: () => Promise<void>
  saveLayoutToServer: (layout: MenuLayout) => Promise<void>
}

export const useMenuLayoutStore = create<MenuLayoutState>((set) => ({
  layout: initialLayout,

  setLayout: (layout: MenuLayout) => {
    localStorage.setItem(STORAGE_KEY, layout)
    applyLayoutToDOM(layout)
    set({ layout })
  },

  loadLayoutFromServer: async () => {
    try {
      const res = await api.get('/v1/anagrafiche/tenant/settings/menu_layout')
      const serverLayout = res.data.menu_layout as MenuLayout
      if (serverLayout && VALID_LAYOUTS.includes(serverLayout)) {
        localStorage.setItem(STORAGE_KEY, serverLayout)
        applyLayoutToDOM(serverLayout)
        set({ layout: serverLayout })
      }
    } catch {
      // Silenzioso — usa layout locale
    }
  },

  saveLayoutToServer: async (layout: MenuLayout) => {
    try {
      await api.put('/v1/anagrafiche/tenant/settings/menu_layout', { menu_layout: layout })
    } catch {
      // Silenzioso — layout gia' salvato localmente
    }
  },
}))
